<template>
  <b-row class="base-row-padded">
    <b-col>
      <h2>Unused Files</h2>
      <div class="d-flex justify-content-between align-items-center">
        <UnusedFilesPagination :perPage="20"
          :queryStructure="queryStructure" @items-updated="itemsUpdated" ref="paginationComponent" />
        <div v-if="this.selectedFiles.length > 0" class="d-flex justify-content-between align-items-center">
          <span class="mr-2">Selected: {{ this.selectedFiles.length }} file(s)</span>
          <b-button class="m-1" variant="danger" size="sm"
              @click.stop="moveToUnusedProxy">Move to Unused</b-button>
        </div>
      </div>
      <b-row>
        <b-table :fields="fields" :items="filesArray" :busy="filesArray === null"
          :select-mode="'single'" :small="true" :hover="true" :responsive="true" :stacked="'sm'" :tbody-tr-class="rowClassFilter" @row-clicked="toggleFile">
          <template #cell(preview)="data">
            <div style="display: inline-block; text-align: center; width: 100%;">
              <img :src="data.item.thumb_url" style="display: inline; max-width: 240px; max-height: 240px;"/>
            </div>
          </template>
          
          <template #cell(name)="data">
            {{ data.item.name }}
          </template>

          <template #cell(id)="data">
            <FileNeededToggle :file="data.item" @is-needed-updated="(v) => {data.item.is_needed = v;}"/>
            <b-button class="ml-2" variant="primary" size="sm" type="button"
              @click.stop="showInFolder(data.item)">Open Folder</b-button>
            <b-button class="ml-2" variant="primary" size="sm" type="button"
              @click.stop="previewFile(data.item)">Preview</b-button>
            <b-button class="ml-2" variant="danger" size="sm" type="button"
              @click.stop="deleteFileProxy(data.item)">Delete</b-button>
          </template>
        </b-table>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
import UnusedFilesPagination from './pagination/UnusedFilesPagination.vue';
import FileNeededToggle from './misc/FileNeededToggle.vue';
import mediaMixin from '@/views/admin/media/mediaMixin';

export default {
  components: { UnusedFilesPagination, FileNeededToggle },
  mixins: [mediaMixin],
  props: {},
  data() {
    return {
      filesArray: null,
      selectedFiles: [],
      queryStructure: {
        pagePropName: 'page',
        perPagePropName: 'per_page',
        searchPropName: 'name',
        responseDataKey: 'files',
      },
      fields: [
        { key: 'preview', label: 'Preview' },
        { key: 'name', label: 'Name' },
        { key: 'id', label: 'Options', tdClass: 'td-no-wrap' },
      ],
      publishStatus: ['Unpublished', 'Published'],
    };
  },
  methods: {
    deleteFileProxy(file) {
      this.deleteFile(file).then(() => {
        if (this.selectedFiles.find(f => f.id === file.id)) {
          this.toggleFile(file);
        }
        this.$refs.paginationComponent.pageChanged();
      }).catch(() => {});
    },
    moveToUnusedProxy() {
      this.moveToUnusedFolder(this.selectedFiles.map(f => f.id)).then(() => {
        this.selectedFiles = [];
        this.$refs.paginationComponent.pageChanged();
      }).catch(() => {});
    },
    itemsUpdated(data) {
      this.filesArray = data;
    },
    totalPlaylistsCount(item) {
      const count = 0 + (item.playlists_count ?? 0) + (item.loop_playlists_count ?? 0) + (item.weekly_playlists_count ?? 0);
      return count;
    },
    toggleFile(file) {
      if(this.selectedFiles.find((f) => f.id === file.id)) {
        this.selectedFiles = this.selectedFiles.filter(f => f.id !== file.id);
      } else {
        this.selectedFiles.push(file);
      }
    },
    rowClassFilter(item) {
      if (this.selectedFiles) {
        const found = this.selectedFiles.find(e => e.id === item.id);
        if (found) {
          return 'bg-primary';
        }
      }
      return '';
    },
    previewFile(file) {
      this.$root.$emit('modal-show-file-preview', {
        title: `Slide preview: ${file.name}`,
        body: '',
        file,
      })
    },
    showInFolder(file) {
      this.$router.push({name: 'media', params: {path: file.directory_id}});
    },
  },
};
</script>
